import { ViewYoutubeComponent } from './static/view-youtube/view-youtube.component';
import { EventComponent } from './static/event/event.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './admin/login/login.component';
import { AboutComponent } from './static/about/about.component';
import { ContactComponent } from './static/contact/contact.component';
import { DiscipleshipComponent } from './static/discipleship/discipleship.component';
import { GetInvolvedComponent } from './static/get-involved/get-involved.component';
import { GiveComponent } from './static/give/give.component';
import { IndexComponent } from './static/index/index.component';
import { SermonsComponent } from './static/sermons/sermons.component';
import { StaticMainComponent } from './static/static-main/static-main.component';
import { DiscipleshipTumiComponent } from './static/discipleship-tumi/discipleship-tumi.component';
import { KingsoopersComponent } from './static/kingsoopers/kingsoopers.component';
import { ForgotPasswordComponent } from './admin/forgot-password/forgot-password.component';
import { UserRegistrationComponent } from './admin/user-registration/user-registration.component';
import { ItimComponent } from './static/itim/itim.component';
import { ItimBookComponent } from './static/itim-book/itim-book.component';
import { OperationsManualComponent } from './static/operations-manual/operations-manual.component';
import { StatementOfFaithComponent } from './static/statement-of-faith/statement-of-faith.component';
import { SpanishItimComponent } from './static/spanish-itim/spanish-itim.component';
import { SpanishItimBookComponent } from './static/spanish-itim-book/spanish-itim-book.component';
import { RussianItimComponent } from './static/russian-itim/russian-itim.component';
import { RussianItimBookComponent } from './static/russian-itim-book/russian-itim-book.component';
import { TrainingSeminarIntroductoryComponent } from './static/training-seminar-introductory/training-seminar-introductory.component';
import { NewSeminarComponent } from './static/new-seminar/new-seminar.component';
import { LearningFounderComponent } from './static/learning-founder/learning-founder.component';
import { IntroductionComponent } from './static/introduction/introduction.component';
import { CertificatesComponent } from './static/certificates/certificates.component';
import { DonatePageComponent } from './donate-page/donate-page.component';

const routes: Routes = [
  {
    path: 'session',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'registration',
    component: UserRegistrationComponent,
  },
  {
    path: '',
    component: StaticMainComponent,
    children: [
      {
        path: '',
        redirectTo: 'index',
        pathMatch: 'full',
      },
      {
        path: 'index',
        component: IndexComponent,
      },
      {
        path: 'skill-skeptical',
        component: NewSeminarComponent,
      },
      {
        path: 'learning',
        component: LearningFounderComponent,
      },
      {
        path: 'introduction',
        component: IntroductionComponent,
      },
      {
        path: 'about',
        component: AboutComponent,
      },
      // {
      //   path: 'discipleship',
      //   component: DiscipleshipComponent
      // },
      {
        path: 'contact-us',
        component: ContactComponent,
      },
      {
        path: 'give',
        component: DonatePageComponent,
      },
      {
        path: 'get-involved',
        component: GetInvolvedComponent,
      },
      {
        path: 'discipleship/iTIM',
        component: DiscipleshipComponent,
      },
      {
        path: 'discipleship/TUMI',
        component: DiscipleshipTumiComponent,
      },
      {
        path: 'give',
        component: GiveComponent,
      },
      {
        path: 'sermons',
        component: SermonsComponent,
      },
      {
        path: 'events',
        component: EventComponent,
      },
      {
        path: 'view',
        component: ViewYoutubeComponent,
      },
      {
        path: 'kingsoopers',
        component: KingsoopersComponent,
      },
      {
        path: 'itim-ministry-tracks/:id/:id2',
        component: ItimComponent,
      },
      {
        path: 'itim-ministry/:id',
        component: ItimBookComponent,
      },
      {
        path: 'operation-manual',
        component: OperationsManualComponent,
      },
      {
        path: 'statement-of-faith',
        component: StatementOfFaithComponent,
      },
      {
        path: 'spanish-itim-ministry-tracks',
        component: SpanishItimComponent,
      },
      {
        path: 'spanish-itim-ministry/:id',
        component: SpanishItimBookComponent,
      },
      {
        path: 'russian-itim-ministry-tracks',
        component: RussianItimComponent,
      },
      {
        path: 'russian-itim-ministry/:id',
        component: RussianItimBookComponent,
      },
      {
        path: 'training-seminar-introductory',
        component: TrainingSeminarIntroductoryComponent,
      },
      {
        path: 'certificates',
        component: CertificatesComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
